import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ImageType, ImageTypes } from '../models/imageType';
import { GalleryTypeService } from '../services/gallery-type.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ImageService } from '../services/image.service';
import { GatewayLibSelects } from '../lib-select-button/lib-select-button.component';
import { AppGlobalsService } from '../app-globals.service';
import { StarbaseLoginService, IUserTokenModel} from 'starbase-login';
import { CONTACTUS_REPORT_PROBLEM, CONTACTUS_SUGGESTION } from '../app.component';
import { BreakpointService, BreakpointState} from '../breakpoint.service';

@Component({
  selector: 'app-gateway-component',
  templateUrl: './gateway.component.html',
  styleUrls: ['./gateway.component.css']
})
export class GatewayComponent implements OnInit {

  // public photosLibraryTypeName: ImageType = new ImageType('Photos');
  // public ordnanceReturnLibraryTypeName: ImageType = new ImageType('Ordnance_Returns');
  // public lettersLibraryTypeName = new ImageType('Letters_and_Diaries');
  // public generalSpecialOrdersLibraryTypeName = new ImageType('General_Special_Orders');
  // public morningReportsLibraryTypeName = new ImageType('Morning Reports');
  // public musterRollsLibraryTypeName = new ImageType('Muster Rolls');
  // public clothingLedgerBooksLibraryTypeName = new ImageType('Clothing Ledger/Books');

  contactUsMode = 0;
  imageTypeCounts: any[];
  photoRecordsCount = null;
  letterAndDiariesRecordsCount = null;
  ordnanceReturnsRecordsCount = null;
  quartermasterSpecRecordsCount = null;
  generalSpecialOrdersRecordsCount = null;
  morningReportRecordsCount = null;
  musterRollRecordsCount = null;
  clothingLedgerRecordsCount = null;
  militaryFormRecordsCount = null;
  civilianResearchRecordsCount = null;
  naraSearchRecordsCount = null;
  searchRecordsCount = null;
  ledgerSetsRecordsCount = null;
  isHandset = false;
  public loggedInUser: IUserTokenModel = null;
  private defaultImgType = new ImageType();
  private _subscription;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  gatewayLibSelects = GatewayLibSelects;

  constructor(private galleryTypeSvc: GalleryTypeService,
      private imgSvc: ImageService,
      private appGlobalsSvc: AppGlobalsService,
      private router: Router,
      private loginSvc: StarbaseLoginService,
      private route: ActivatedRoute,
      private breakpointService: BreakpointService,
      private cd: ChangeDetectorRef) {
    this.defaultImgType.typeOfImage = '';
    this.defaultImgType.uid = 0;
   }

  ngOnInit() {
    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    );
    this.getAllImageTypeCounts();
    // eslint-disable-next-line max-len
    this.imgSvc.fillFilterOptionsCache(); // start loading the filter options here so they're cached sooner when the user clicks a library choice
    this.galleryTypeSvc.setPrePrintedMode(false).subscribe();
    this.galleryTypeSvc.CivilianResearchMode = false;
    this.galleryTypeSvc.LedgerSetsMode = false;
    this.galleryTypeSvc.setGalleryType(this.defaultImgType);
    this.galleryTypeSvc.clearCurrentFilterOptions(); // get rid of any 'remembered' filters chosen as we move to another library.
    this.route.queryParams.subscribe(params => {
      this.contactUsMode = params.contactus;
    });
    if (this.contactUsMode) {

      switch (+this.contactUsMode) {
        case 1:
          this.appGlobalsSvc.openContactRequest('Contact Us');
          break;
        case 2:
          this.appGlobalsSvc.openContactRequest('Support Center');
          break;
        case 3:
          this.appGlobalsSvc.openContactRequest(CONTACTUS_REPORT_PROBLEM);
          break;
        case 4:
          this.appGlobalsSvc.openContactRequest(CONTACTUS_SUGGESTION);
          break;
        default:
          break;
      }
    }
   }

  setPageOut(pageImgType: ImageType = this.defaultImgType): void { // goto particular image type gallery (or all)
    if (pageImgType.typeOfImage === this.gatewayLibSelects.QMSpecsLibSelect.name) {
      this.openQuartermasterManuals();
      return;
    }
    if (pageImgType.prePrintedFormType === true) {
      this.openPrePrintedMilitaryForms();
      return;
    }

    if (pageImgType.typeOfImage === 'Ledger_Sets') {
      this.openLedgersLibrary();
      return;
    }

    this.galleryTypeSvc.setGalleryType(pageImgType);
    this.router.navigate(['/library']);
  }

  openLedgersLibrary(): void {
    console.log('openLedgersLibrary called');
    this.galleryTypeSvc.LedgerSetsMode = true;
    this.setPageOut();
  }

  openSearch(): void { // Search by Source/Call #
    this.galleryTypeSvc.setGalleryType(this.defaultImgType);
    this.router.navigate(['/search']);
  }

  getAllImageTypeCounts() {
    const toPassArray = [
    ImageTypes['Photos'],
    ImageTypes['Letters & Diaries'],
    ImageTypes['Ordnance_Returns'],
    ImageTypes['General_Special_Orders'],
    ImageTypes['Morning_Reports'],
    ImageTypes['Muster_Rolls'],
    ImageTypes['Clothing_Ledger/Books'],
    ];

    this.loggedInUser = this.loginSvc.isLoggedIn() && this.loginSvc.getUserModel();
    let roleBool = false;

    if(this.loggedInUser.isAdmin() || this.loggedInUser.isInUserGroup('Librarian')){
      roleBool = true;
    }

    this.imgSvc.getAllImageTypeCount(toPassArray, roleBool).subscribe(returnArray => {
        this.photoRecordsCount = returnArray[0][1];
        this.letterAndDiariesRecordsCount = returnArray[1][1];
        this.ordnanceReturnsRecordsCount = returnArray[2][1];
        this.generalSpecialOrdersRecordsCount = returnArray[3][1];
        this.morningReportRecordsCount = returnArray[4][1];
        this.musterRollRecordsCount = returnArray[5][1];
        this.clothingLedgerRecordsCount = returnArray[6][1];
        this.civilianResearchRecordsCount = returnArray[7][1];
        this.militaryFormRecordsCount = returnArray[8][1];
        this.quartermasterSpecRecordsCount = returnArray[9][1];
        this.naraSearchRecordsCount = returnArray[10][1];
        this.searchRecordsCount = returnArray[11][1];
        this.ledgerSetsRecordsCount = returnArray[12][1];
        this.cd.detectChanges();
      }
    );
  }

  formatNumber(x){
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }


  noOfRecordsString(type: string){
    switch(type){
      case 'photo':{
        return this.photoRecordsCount == null ? 'loading' : this.formatNumber(this.photoRecordsCount) + ' Records';
      }
      case 'letterAndDiaries':{
        return this.letterAndDiariesRecordsCount == null ? 'loading' : this.formatNumber(this.letterAndDiariesRecordsCount) + ' Records';
      }
      case 'ordnanceReturns':{
        return this.ordnanceReturnsRecordsCount == null ? 'loading' : this.formatNumber(this.ordnanceReturnsRecordsCount) + ' Records';
      }
      case 'generalSpecialOrders':{
        // eslint-disable-next-line max-len
        return this.generalSpecialOrdersRecordsCount == null ? 'loading' : this.formatNumber(this.generalSpecialOrdersRecordsCount) + ' Records';
      }
      case 'morningReports':{
        return this.morningReportRecordsCount == null ? 'loading' : this.formatNumber(this.morningReportRecordsCount) + ' Records';
      }
      case 'musterRolls':{
        return this.musterRollRecordsCount == null ? 'loading' : this.formatNumber(this.musterRollRecordsCount) + ' Records';
      }
      case 'clothingLedger':{
        return this.clothingLedgerRecordsCount == null ? 'loading' : this.formatNumber(this.clothingLedgerRecordsCount) + ' Records';
      }
      case 'quartermaster':{
        // eslint-disable-next-line max-len
        return this.quartermasterSpecRecordsCount == null ? 'loading' : this.formatNumber(this.quartermasterSpecRecordsCount) + ' Records';
      }
      case 'civilian':{
        return this.civilianResearchRecordsCount == null ? 'loading' : this.formatNumber(this.civilianResearchRecordsCount) + ' Records';
      }
      case 'military': {
        return this.militaryFormRecordsCount == null ? 'loading' : this.formatNumber(this.militaryFormRecordsCount) + ' Records';
      }
      case 'nara': {
        return this.naraSearchRecordsCount == null ? 'loading' : this.formatNumber(this.naraSearchRecordsCount) + ' Records';
      }
      case 'search': {
        return this.searchRecordsCount == null ? 'loading' : this.formatNumber(this.searchRecordsCount) + ' Records';
      }
      case 'ledgerSets': {
        if (this.ledgerSetsRecordsCount == null) {
          return 'loading';
        } else if (this.ledgerSetsRecordsCount === 0) {
          return 'No Records';
        } else {
          return this.formatNumber(this.ledgerSetsRecordsCount) + ' Ledgers';
        }
      }
    }
  }

  openMicrofilmSearch(): void {
    this.galleryTypeSvc.setGalleryType(this.defaultImgType);
    this.router.navigate(['/search/microfilm']);
  }

  openQuartermasterManuals(): void { // QM & Ordnance Specs
    this.galleryTypeSvc.setGalleryType(this.defaultImgType);
    this.router.navigate(['/quartermaster-manuals']);
  }

  openPrePrintedMilitaryForms(): void {
    this.galleryTypeSvc.setPrePrintedMode(true).subscribe(() =>
      this.setPageOut());
  }

  openCivilianResearch(): void {
    this.galleryTypeSvc.CivilianResearchMode = true;
    this.setPageOut();
  }

}
